import {Booking, BookingSettings, DraftBooking, ExpandedBooking} from 'services/entities/booking';
import {validateDiscount} from 'services/discounts';
import {isDraftBooking} from 'services/bookings/drafts';
import {DateTime, TimeSpan} from 'util/time';

export function getBookingHash(booking: DraftBooking|Booking): string {
  let hash = `${booking.space}`;
  if('times' in booking) {
    for(const t of booking.times) {
      hash += `-${t.startTime}-${t.endTime}-${t.includeFlexiTicket}`;
    }
  } else {
    hash += `-${booking.startTime}-${booking.endTime}`;
  }
  for(const pr of booking.products) {
    hash += `-${pr.sku}-${pr.quantity}`;
    for(const key of Object.keys(pr.optionValues)) {
      hash += `-${key}-${pr.optionValues[key]}`;
    }
  }
  for(const discount of booking.discounts) {
    if(typeof(discount) === 'string') {
      hash += `-${discount}`;
    } else {
      hash += `-${discount.code}`;
    }
  }
  return hash;
}

export function formatTimeUntilBooking(ts: TimeSpan): string {
  const days = Math.floor(ts.totalDays);
  if(days <= 0) {
    return 'less than 1 day';
  } else if(days === 1) {
    return '1 day';
  } else {
    return `${days} days`;
  }
}

export async function validateBookingDiscounts(discountCodes:string[]): Promise<{[index:string]:Error}> {
  const errors:{[index:string]:Error} = {};
  for(const code of discountCodes) {
    try {
      await validateDiscount(code);
    } catch(ex) {
      errors[code] = ex;
    }
  }
  return errors;
}

export function canModifyBookingDiscounts(booking: DraftBooking|Booking): boolean {
  return isDraftBooking(booking) && !booking.code;
}

export function isFlexiTicketAvailable(date: DateTime, settings: BookingSettings): boolean {
  const currentDate = DateTime.now(settings.defaultTimeZone);
  return date.unitDiff(currentDate, 'days') >= settings.flexiTicketMinDateOffset;
}

export function formatBookingDate(booking: Booking|ExpandedBooking): string {
  return booking.startTime.format("ddd DD MMM");
}

export function formatBookingTime(booking: Booking|ExpandedBooking): string {
  return `${booking.startTime.format("h:mma")} - ${booking.endTime.format("h:mma")}`;
}